import { Table } from "@kyan/ui";

import { getColumns } from "./Summary.config";
import { useSummaryController } from "./Summary.controller";

export const Summary = () => {
  const { data } = useSummaryController();
  const columns = getColumns();

  return (
    <Table
      hideHeader
      data={data}
      columns={columns}
      classes={{
        wrapper: "bg-transparent",
        table: "border-b-0",
        row: "px-8",
        cellClassName: "py-3",
      }}
    />
  );
};
